// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"239f3c46","613":"60669188"}[chunkId] + ".chunk.js";
};